import { createSelector } from '@reduxjs/toolkit';

import { MAX_CUSTOM_BACKGROUNDS } from '../services';

import type { RootState } from 'store';

const selectCustomBackgroundsState = (state: RootState) => state.customBackgrounds;

export const selectCustomBackgrounds = createSelector(selectCustomBackgroundsState, ({ items }) => items);

export const selectIsImportingCustomBackground = createSelector(
  selectCustomBackgroundsState,
  ({ isImporting }) => isImporting
);

export const selectCustomBackgroundImportError = createSelector(
  selectCustomBackgroundsState,
  ({ importError }) => importError
);

export const selectCanAddCustomBackground = createSelector(
  selectCustomBackgrounds,
  ({ length }) => length < MAX_CUSTOM_BACKGROUNDS
);
